import React from 'react'
import Reveal from '../../Common/Reveal/Reveal'
import styles from './Values.module.scss'

const values = [
  {
    title: 'Merchant obsession',
    text: 'Every decision starts with the outcomes our merchants need — not features for their own sake.',
    icon: (
      <path d='M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 1 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z' />
    ),
  },
  {
    title: 'Built for scale',
    text: 'A headless, API-first foundation engineered to grow from first sale to enterprise volume.',
    icon: (
      <>
        <path d='M3 3v18h18' />
        <path d='M7 15l4-4 3 3 5-6' />
      </>
    ),
  },
  {
    title: 'Move with speed',
    text: 'We launch faster and iterate relentlessly, so our partners ship while others are still planning.',
    icon: <path d='M13 2L3 14h7l-1 8 11-14h-8l1-6z' />,
  },
  {
    title: 'Partners, not vendors',
    text: 'Like a trainer behind the team, we back the people building what comes next for the long run.',
    icon: (
      <>
        <path d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2' />
        <circle cx='9' cy='7' r='4' />
        <path d='M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75' />
      </>
    ),
  },
]

const Values = () => {
  return (
    <section className={styles['values']}>
      <Reveal className={styles['heading-block']}>
        <span className={styles['eyebrow']}>What drives us</span>
        <h2 className={styles['heading']}>Principles behind every build</h2>
        <p className={styles['subtitle']}>
          The values that shape how we partner, design, and ship.
        </p>
      </Reveal>

      <div className={styles['grid']}>
        {values.map((value, index) => (
          <Reveal key={value.title} delay={index * 90} className={styles['card-wrap']}>
            <div className={styles['card']}>
              <span className={styles['icon']}>
                <svg
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth={1.8}
                  strokeLinecap='round'
                  strokeLinejoin='round'
                >
                  {value.icon}
                </svg>
              </span>
              <h3 className={styles['title']}>{value.title}</h3>
              <p className={styles['text']}>{value.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  )
}

export default Values
